/**
 * Sprint 22 — KuvioSpinner (ported from the Sprint 3.2 chat UI). The 9-square
 * animated mark shown while the assistant is streaming. Styling lives in
 * index.css (`.kuvio-spinner*`, loaded app-wide via main.tsx).
 */
import { useState } from "react";

const SPINNER_VARIANTS = [
  "breathe",
  "cascade",
  "orbit",
  "shimmer",
  "sparkle",
  "typewriter",
] as const;

export function KuvioSpinner() {
  const [variant] = useState(
    () => SPINNER_VARIANTS[Math.floor(Math.random() * SPINNER_VARIANTS.length)]!,
  );

  return (
    <div className={`kuvio-spinner kuvio-spinner--${variant}`}>
      <div className="kuvio-spinner__sq kuvio-spinner__sq--purple" />
      <div className="kuvio-spinner__sq kuvio-spinner__sq--ghost kuvio-spinner__sq--ghost-purple" />
      <div className="kuvio-spinner__sq kuvio-spinner__sq--coral" />
      <div className="kuvio-spinner__sq kuvio-spinner__sq--blue" />
      <div className="kuvio-spinner__sq kuvio-spinner__sq--amber" />
      <div className="kuvio-spinner__sq kuvio-spinner__sq--ghost kuvio-spinner__sq--ghost-amber" />
      <div className="kuvio-spinner__sq kuvio-spinner__sq--coral" />
      <div className="kuvio-spinner__sq kuvio-spinner__sq--ghost kuvio-spinner__sq--ghost-teal" />
      <div className="kuvio-spinner__sq kuvio-spinner__sq--teal" />
    </div>
  );
}
